import { actionCreator } from '@ardoq/rxbeach';
import { APITagAttributes, ArdoqId, UnpersistedEntity } from '@ardoq/api-types';

interface DeleteTags {
  readonly cids: string[];
}
export const deleteTags = actionCreator<DeleteTags>('[TagActions] DELETE_TAGS');

interface UntagComponent {
  readonly tagCid: string;
  readonly componentCid: string;
}
export const untagComponent = actionCreator<UntagComponent>(
  '[TagActions] UNTAG_COMPONENT'
);

interface UntagReference {
  readonly tagCid: string;
  readonly referenceCid: string;
}
export const untagReference = actionCreator<UntagReference>(
  '[TagActions] UNTAG_REFERENCE'
);

interface TagComponents {
  readonly tagId: string | null;
  readonly componentIds: Set<string>;
}
export const tagComponents = actionCreator<TagComponents>(
  '[TagActions] TAG_COMPONENTS'
);

interface FilterTagPayload {
  id: ArdoqId;
  exclude: boolean;
}
export const editTag = actionCreator<ArdoqId>('[TagActions] EDIT_TAG');

export const deleteTag = actionCreator<ArdoqId>('[TagActions] DELETE_TAG');

export const filterTag = actionCreator<FilterTagPayload>(
  '[TagActions] FILTER_TAG'
);

export const updateTag = actionCreator<APITagAttributes>(
  '[TagActions] UPDATE_TAG'
);

export const createTag = actionCreator<UnpersistedEntity<APITagAttributes>>(
  '[TagActions] CREATE_TAG'
);

export const showAddTagDialog = actionCreator<{ rootWorkspace: ArdoqId }>(
  '[TagActions] SHOW_ADD_TAG_DIALOG'
);

type TagComponentPayload = {
  readonly tagName: string;
  readonly componentId: ArdoqId;
  readonly rootWorkspaceId: ArdoqId;
};
export const tagComponent = actionCreator<TagComponentPayload>(
  '[TagActions] TAG_COMPONENT'
);

type TagReferencePayload = {
  readonly tagName: string;
  readonly referenceId: ArdoqId;
  readonly rootWorkspaceId: ArdoqId;
};
export const tagReference = actionCreator<TagReferencePayload>(
  '[TagActions] TAG_REFERENCE'
);

type ApplyTagAttributesPayload = { _id: ArdoqId } & Partial<APITagAttributes>;
export const applyTagAttributes = actionCreator<ApplyTagAttributesPayload>(
  '[TagActions] APPLY_TAG_ATTRIBUTES'
);
